(function() {
  'use strict';

  // ===== STICKY HEADER =====
  const header = document.getElementById('header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ===== FAQ ACCORDION =====
  document.querySelectorAll('.faq-item__question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const item = btn.parentElement;
      const isActive = item.classList.contains('active');
      const answer = item.querySelector('.faq-item__answer');

      // Close all items and reset ARIA
      document.querySelectorAll('.faq-item').forEach(function(i) {
        i.classList.remove('active');
        const iBtn = i.querySelector('.faq-item__question');
        const iAnswer = i.querySelector('.faq-item__answer');
        if (iBtn) iBtn.setAttribute('aria-expanded', 'false');
        if (iAnswer) iAnswer.setAttribute('aria-hidden', 'true');
      });

      // Open clicked item if it wasn't already active
      if (!isActive) {
        item.classList.add('active');
        btn.setAttribute('aria-expanded', 'true');
        if (answer) answer.setAttribute('aria-hidden', 'false');
      }
    });
  });

  // ===== SMOOTH SCROLL =====
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      const href = a.getAttribute('href');
      if (href === '#') return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ===== INTERSECTION OBSERVER FOR FADE-UP =====
  if ('IntersectionObserver' in window) {
    const fadeObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.fade-up').forEach(function(el) {
      fadeObserver.observe(el);
    });
  }

  // ===== MOBILE MENU =====
  const menuToggle = document.querySelector('.header__hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');
  const menuOverlay = document.querySelector('.mobile-menu-overlay');
  const menuClose = document.querySelector('.mobile-menu__close button');

  function openMenu() {
    if (mobileMenu && menuOverlay) {
      mobileMenu.classList.add('active');
      menuOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeMenu() {
    if (mobileMenu && menuOverlay) {
      mobileMenu.classList.remove('active');
      menuOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);

  // ===== CART QUANTITY CONTROLS =====
  document.querySelectorAll('.product-form__quantity').forEach(function(wrapper) {
    const input = wrapper.querySelector('input');
    const minus = wrapper.querySelector('[data-action="minus"]');
    const plus = wrapper.querySelector('[data-action="plus"]');

    if (minus) {
      minus.addEventListener('click', function() {
        const val = parseInt(input.value, 10) || 1;
        if (val > 1) input.value = val - 1;
      });
    }
    if (plus) {
      plus.addEventListener('click', function() {
        const val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
      });
    }
  });

  // ===== CART LINE ITEM QUANTITY UPDATE =====
  function initCartQuantityControls() {
    document.querySelectorAll('.cart-item__quantity').forEach(function(wrapper) {
      const input = wrapper.querySelector('input');
      const minus = wrapper.querySelector('[data-action="minus"]');
      const plus = wrapper.querySelector('[data-action="plus"]');
      const lineKey = wrapper.dataset.lineKey;

      function updateCart(quantity) {
        wrapper.style.opacity = '0.5';
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: quantity })
        })
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          // Update all cart count badges
          document.querySelectorAll('.cart-count').forEach(function(el) {
            el.textContent = cart.item_count;
          });
          // Re-render cart section via Section Rendering API
          return fetch('?sections=main-cart');
        })
        .then(function(res) { return res.json(); })
        .then(function(sections) {
          const cartSection = document.querySelector('.section');
          if (sections['main-cart'] && cartSection) {
            const temp = document.createElement('div');
            temp.innerHTML = sections['main-cart'];
            const newContent = temp.querySelector('.section');
            if (newContent) {
              cartSection.replaceWith(newContent);
              initCartQuantityControls();
              initCartRemoveButtons();
            }
          }
        })
        .catch(function() {
          window.location.reload();
        });
      }

      if (minus) {
        minus.addEventListener('click', function() {
          const val = parseInt(input.value, 10) || 1;
          updateCart(Math.max(0, val - 1));
        });
      }
      if (plus) {
        plus.addEventListener('click', function() {
          const val = parseInt(input.value, 10) || 1;
          updateCart(val + 1);
        });
      }
    });
  }

  // ===== CART REMOVE BUTTON =====
  function initCartRemoveButtons() {
    document.querySelectorAll('.cart-item__remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const lineKey = btn.dataset.lineKey;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: 0 })
        })
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          document.querySelectorAll('.cart-count').forEach(function(el) {
            el.textContent = cart.item_count;
          });
          return fetch('?sections=main-cart');
        })
        .then(function(res) { return res.json(); })
        .then(function(sections) {
          const cartSection = document.querySelector('.section');
          if (sections['main-cart'] && cartSection) {
            const temp = document.createElement('div');
            temp.innerHTML = sections['main-cart'];
            const newContent = temp.querySelector('.section');
            if (newContent) {
              cartSection.replaceWith(newContent);
              initCartQuantityControls();
              initCartRemoveButtons();
            }
          }
        })
        .catch(function() {
          window.location.reload();
        });
      });
    });
  }

  initCartQuantityControls();
  initCartRemoveButtons();

  // ===== PRODUCT PAGE: THUMBNAIL GALLERY =====
  document.querySelectorAll('.product-page__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      const mainImage = document.querySelector('.product-page__main-image img');
      if (mainImage) {
        mainImage.src = thumb.dataset.fullSrc;
        mainImage.alt = thumb.querySelector('img').alt;
      }
      document.querySelectorAll('.product-page__thumb').forEach(function(t) {
        t.classList.remove('active');
      });
      thumb.classList.add('active');
    });
  });

  // ===== QUICK ADD TO CART =====
  document.querySelectorAll('.product-card__quick-add').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      const productUrl = btn.dataset.productUrl;

      if (productUrl && !variantId) {
        window.location.href = productUrl;
        return;
      }

      if (variantId) {
        btn.textContent = 'Adding...';
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          btn.textContent = 'Added!';
          fetch('/cart.js')
            .then(function(res) { return res.json(); })
            .then(function(cart) {
              document.querySelectorAll('.cart-count').forEach(function(el) {
                el.textContent = cart.item_count;
              });
            });
          setTimeout(function() {
            btn.textContent = 'Quick Add';
            btn.disabled = false;
          }, 1500);
        })
        .catch(function() {
          btn.textContent = 'Quick Add';
          btn.disabled = false;
        });
      }
    });
  });
})();
